import {PropertiesOnly} from "@livechat/shared";
import {InvalidArgumentException} from "./exceptions";
import {TagBase} from "./tag-base";

export class CustomTag extends TagBase {
  companiesIds: string[]

  private constructor(tag: PropertiesOnly<TagBase>, companiesIds: string[]) {
    super(tag);
    this.companiesIds = companiesIds
    this.validateCustomTag()
  }

  static getInstance(params: { tag: PropertiesOnly<TagBase>, companies: string[] }) {
    return new CustomTag(
      params.tag,
      params.companies
    )
  }

  protected validateCustomTag() {
    if (!this.companiesIds?.length) {
      throw new InvalidArgumentException('companiesIds', 'required')
    }
  }
}
